import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/imgIcons/intercom.png'
import _imports_1 from '@/assets/images/imgIcons/camera.png'
import _imports_2 from '@/assets/images/imgIcons/actuator.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-0b764d8c")

_pushScopeId("data-v-0b764d8c")
const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_3 = { class: "mt-2" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = {
  key: 0,
  class: "p-tabview p-tabview--custom plant-c300eos-settings"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "setting-box" }
const _hoisted_8 = { class: "setting-title" }
const _hoisted_9 = { class: "setting-item" }
const _hoisted_10 = { class: "setting-label" }
const _hoisted_11 = { class: "setting-value" }
const _hoisted_12 = { class: "setting-item" }
const _hoisted_13 = { class: "setting-label" }
const _hoisted_14 = { class: "setting-value" }
const _hoisted_15 = { class: "setting-item" }
const _hoisted_16 = { class: "setting-label" }
const _hoisted_17 = { class: "setting-value" }
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_19 = { class: "setting-box" }
const _hoisted_20 = { class: "setting-title" }
const _hoisted_21 = { class: "setting-item" }
const _hoisted_22 = { class: "setting-label" }
const _hoisted_23 = { class: "setting-item" }
const _hoisted_24 = { class: "setting-label" }
const _hoisted_25 = { class: "setting-value" }
const _hoisted_26 = { class: "setting-item" }
const _hoisted_27 = { class: "setting-label" }
const _hoisted_28 = { class: "setting-value" }
const _hoisted_29 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_30 = { class: "setting-box" }
const _hoisted_31 = { class: "setting-title" }
const _hoisted_32 = { class: "setting-item" }
const _hoisted_33 = { class: "setting-label" }
const _hoisted_34 = { class: "setting-value" }
const _hoisted_35 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_36 = { class: "setting-box" }
const _hoisted_37 = { class: "setting-title" }
const _hoisted_38 = { class: "setting-item" }
const _hoisted_39 = { class: "setting-label" }
const _hoisted_40 = { class: "setting-value" }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "setting-box" }
const _hoisted_43 = { class: "setting-item setting-item-multiline" }
const _hoisted_44 = { class: "setting-title" }
const _hoisted_45 = { class: "d-flex" }
const _hoisted_46 = { class: "setting-item setting-item-multiline" }
const _hoisted_47 = /*#__PURE__*/_createVNode("span", { class: "setting-label" }, "N", -1)
const _hoisted_48 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_49 = { class: "setting-item" }
const _hoisted_50 = /*#__PURE__*/_createVNode("span", { class: "setting-label" }, "P", -1)
const _hoisted_51 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_52 = { class: "setting-item" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "setting-label" }, "M", -1)
const _hoisted_54 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_55 = { class: "setting-item" }
const _hoisted_56 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_57 = { class: "d-flex" }
const _hoisted_58 = { class: "w-100" }
const _hoisted_59 = { class: "setting-item" }
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = { class: "d-flex" }
const _hoisted_62 = { class: "w-100" }
const _hoisted_63 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_64 = { class: "setting-item mb-3" }
const _hoisted_65 = { class: "d-flex align-items-center mb-3 b-3" }
const _hoisted_66 = { class: "setting-title w-100" }
const _hoisted_67 = { class: "vde-function-list-item" }
const _hoisted_68 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "intercom"
}, null, -1)
const _hoisted_69 = { class: "btn-stripped" }
const _hoisted_70 = { class: "btn-stripped text-danger" }
const _hoisted_71 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_72 = { class: "setting-item mb-3" }
const _hoisted_73 = { class: "d-flex align-items-center mb-3" }
const _hoisted_74 = { class: "setting-title w-100" }
const _hoisted_75 = { class: "vde-function-list-item" }
const _hoisted_76 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  alt: "camera"
}, null, -1)
const _hoisted_77 = { class: "btn-stripped" }
const _hoisted_78 = { class: "btn-stripped text-danger" }
const _hoisted_79 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_80 = { class: "setting-item" }
const _hoisted_81 = { class: "d-flex align-items-center mb-3" }
const _hoisted_82 = { class: "setting-title w-100" }
const _hoisted_83 = { class: "vde-function-list-item" }
const _hoisted_84 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "actuator"
}, null, -1)
const _hoisted_85 = { class: "btn-stripped" }
const _hoisted_86 = { class: "btn-stripped text-danger" }
const _hoisted_87 = { key: 2 }
const _hoisted_88 = { class: "setting-box" }
const _hoisted_89 = { class: "setting-title" }
const _hoisted_90 = { class: "setting-item setting-item-multiline" }
const _hoisted_91 = { class: "setting-label" }
const _hoisted_92 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_93 = { class: "d-flex" }
const _hoisted_94 = { class: "w-100" }
const _hoisted_95 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_96 = { class: "setting-item setting-item-multiline" }
const _hoisted_97 = { class: "setting-label" }
const _hoisted_98 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_99 = { class: "mt-3" }
const _hoisted_100 = { class: "p-field-radiobutton" }
const _hoisted_101 = { for: `option-unitofmeasure-celsius` }
const _hoisted_102 = { class: "p-field-radiobutton" }
const _hoisted_103 = { for: `option-unitofmeasure-fahrenheit` }
const _hoisted_104 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_105 = { class: "setting-item" }
const _hoisted_106 = { class: "setting-title" }
const _hoisted_107 = { class: "d-flex" }
const _hoisted_108 = { class: "w-100" }
const _hoisted_109 = { class: "setting-label mb-3" }
const _hoisted_110 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_111 = { class: "text-right" }
const _hoisted_112 = { class: "setting-item" }
const _hoisted_113 = { class: "setting-label mb-3" }
const _hoisted_114 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_115 = { class: "text-right" }
const _hoisted_116 = { class: "setting-item d-flex" }
const _hoisted_117 = { class: "w-100" }
const _hoisted_118 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_119 = { class: "setting-item" }
const _hoisted_120 = { class: "setting-title" }
const _hoisted_121 = { class: "setting-label" }
const _hoisted_122 = { class: "setting-value setting-inline-block" }
const _hoisted_123 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_124 = {
  key: 0,
  class: "setting-label"
}
const _hoisted_125 = { class: "setting-value setting-inline-block" }
const _hoisted_126 = /*#__PURE__*/_createVNode("hr", { class: "border-bottom" }, null, -1)
const _hoisted_127 = { class: "setting-item" }
const _hoisted_128 = { class: "setting-title" }
const _hoisted_129 = { class: "d-flex" }
const _hoisted_130 = { class: "w-100" }
const _hoisted_131 = { class: "setting-item" }
const _hoisted_132 = { class: "d-flex" }
const _hoisted_133 = { key: 0 }
const _hoisted_134 = { class: "setting-item setting-item-multiline" }
const _hoisted_135 = { key: 0 }
const _hoisted_136 = { class: "mt-3" }
const _hoisted_137 = { class: "p-field-radiobutton" }
const _hoisted_138 = { for: `option-season-withdate` }
const _hoisted_139 = { class: "p-field-radiobutton" }
const _hoisted_140 = { for: `option-season-withcontact` }
const _hoisted_141 = { class: "p-field-radiobutton" }
const _hoisted_142 = { for: `option-season-withtemperature` }
const _hoisted_143 = {
  key: 0,
  class: "setting-item setting-item-multiline"
}
const _hoisted_144 = { class: "mt-3 d-flex" }
const _hoisted_145 = { class: "mr-3" }
const _hoisted_146 = { class: "mt-3 d-flex" }
const _hoisted_147 = { class: "mr-3" }
const _hoisted_148 = {
  key: 1,
  class: "setting-item"
}
const _hoisted_149 = { class: "setting-label" }
const _hoisted_150 = { class: "setting-value setting-inline-block" }
const _hoisted_151 = { class: "mt-2" }
const _hoisted_152 = {
  key: 3,
  class: "apartment__footer"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_TabsEnumFilter = _resolveComponent("TabsEnumFilter")
  const _component_Button = _resolveComponent("Button")
  const _component_ToggleSwitchButton = _resolveComponent("ToggleSwitchButton")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Slider = _resolveComponent("Slider")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_DialogConfirmChangeLanguage = _resolveComponent("DialogConfirmChangeLanguage")
  const _component_ModalAddEditVdeFunction = _resolveComponent("ModalAddEditVdeFunction")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", null, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withId(() => [
              _hoisted_2,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentPlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_3, _toDisplayString(_ctx.mxServerLabel), 1),
          _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("plantC300EOSSettings.descPage")), 1)
        ])
      ])
    ]),
    (_ctx.c300eosSettings)
      ? (_openBlock(), _createBlock("div", _hoisted_5, [
          _createVNode(_component_TabsEnumFilter, {
            "enum-tabs": _ctx.tabsFilters,
            "hidden-tabs": _ctx.hiddenTabs,
            "selected-tab": _ctx.selectedTab,
            onSelectTab: _ctx.onSelectTab
          }, null, 8, ["enum-tabs", "hidden-tabs", "selected-tab", "onSelectTab"]),
          (_ctx.selectedTab === '0')
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t("AppResource.ServerInfo")), 1),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.FirmwareVersionUpper")), 1),
                    _createVNode("span", _hoisted_11, _toDisplayString(_ctx.c300eosSettings.firmwareVersion), 1)
                  ]),
                  _createVNode("div", _hoisted_12, [
                    _createVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("AppResource.ServerId")), 1),
                    _createVNode("span", _hoisted_14, _toDisplayString(_ctx.c300eosSettings.gwId), 1)
                  ]),
                  _createVNode("div", _hoisted_15, [
                    _createVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("AppResource.LastSyncOnCloudUpper")), 1),
                    _createVNode("span", _hoisted_17, _toDisplayString(_ctx.getParsedDate(_ctx.currentPlant?.lastModify)), 1)
                  ])
                ]),
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode("h4", _hoisted_20, _toDisplayString(_ctx.$t("AppResource.DateAndTime")), 1),
                  _createVNode("div", _hoisted_21, [
                    _createVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("AppResource.AutoSetupUpper")), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.c300eosSettings.isAutoSetupEnabled ? "ON" : "OFF"), 1)
                  ]),
                  _createVNode("div", _hoisted_23, [
                    _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("AppResource.TimeZoneUpper")), 1),
                    _createVNode("span", _hoisted_25, _toDisplayString(_ctx.c300eosSettings.TimeZone || "-"), 1)
                  ]),
                  _createVNode("div", _hoisted_26, [
                    _createVNode("span", _hoisted_27, _toDisplayString(_ctx.$t("AppResource.NtpServerUpper")), 1),
                    _createVNode("span", _hoisted_28, _toDisplayString(_ctx.c300eosSettings.ntpServer || "-"), 1)
                  ])
                ]),
                _hoisted_29,
                _createVNode("div", _hoisted_30, [
                  _createVNode("h4", _hoisted_31, _toDisplayString(_ctx.$t("AppResource.Email")), 1),
                  _createVNode("div", _hoisted_32, [
                    _createVNode("span", _hoisted_33, _toDisplayString(_ctx.$t("AppResource.Username")), 1),
                    _createVNode("span", _hoisted_34, _toDisplayString(_ctx.account.username), 1)
                  ])
                ]),
                _hoisted_35,
                _createVNode("div", _hoisted_36, [
                  _createVNode("h4", _hoisted_37, _toDisplayString(_ctx.$t("AppResource.LanguageSettings")), 1),
                  _createVNode("div", _hoisted_38, [
                    _createVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("AppResource.LanguageSettings")), 1),
                    _createVNode("span", _hoisted_40, _toDisplayString(_ctx.Language[_ctx.c300eosSettings.language]), 1)
                  ]),
                  (_ctx.plantC300EosSettingsEditEnabled)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-rounded p-button-outlined py-1",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showChangeLanguageConfirm()))
                      }, {
                        default: _withId(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Change")), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedTab === '1')
            ? (_openBlock(), _createBlock("div", _hoisted_41, [
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, [
                    _createVNode("h4", _hoisted_44, _toDisplayString(_ctx.$t(
                                "plantC300EOSSettings.DoorEntryParametrs"
                            ).toLowerCase()), 1)
                  ]),
                  _createVNode("div", _hoisted_45, [
                    _createVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _hoisted_48,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "input-border-bottom",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.c300eosSettings.nValue = $event)),
                        disabled: !_ctx.plantC300EosSettingsEditEnabled
                      }, null, 8, ["disabled"]), [
                        [_vModelText, _ctx.c300eosSettings.nValue]
                      ])
                    ]),
                    _createVNode("div", _hoisted_49, [
                      _hoisted_50,
                      _hoisted_51,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "input-border-bottom",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.c300eosSettings.pValue = $event)),
                        disabled: !_ctx.plantC300EosSettingsEditEnabled
                      }, null, 8, ["disabled"]), [
                        [_vModelText, _ctx.c300eosSettings.pValue]
                      ])
                    ]),
                    _createVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _hoisted_54,
                      _withDirectives(_createVNode("input", {
                        type: "text",
                        class: "input-border-bottom",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.c300eosSettings.mValue = $event)),
                        disabled: !_ctx.plantC300EosSettingsEditEnabled
                      }, null, 8, ["disabled"]), [
                        [_vModelText, _ctx.c300eosSettings.mValue]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_55, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t("AppResource.AnsweringMachine")), 1),
                    _hoisted_56,
                    _createVNode("div", _hoisted_57, [
                      _createVNode("div", _hoisted_58, _toDisplayString(_ctx.$t(
                                    "plantC300EOSSettings.SetAsPrimaryEntryUnitDESC"
                                )), 1),
                      _createVNode(_component_ToggleSwitchButton, {
                        disabled: !_ctx.plantC300EosSettingsEditEnabled,
                        modelValue: _ctx.c300eosSettings.isAnsweringMachineEnabled,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.c300eosSettings.isAnsweringMachineEnabled = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_59, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t("AppResource.ProfessionalStudio")), 1),
                    _hoisted_60,
                    _createVNode("div", _hoisted_61, [
                      _createVNode("div", _hoisted_62, _toDisplayString(_ctx.$t(
                                    "plantC300EOSSettings.ProfessionalStudioDESC"
                                )), 1),
                      _createVNode(_component_ToggleSwitchButton, {
                        disabled: !_ctx.plantC300EosSettingsEditEnabled,
                        modelValue: 
                                _ctx.c300eosSettings.isProfessionalStudioEnabled
                            ,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (
                                _ctx.c300eosSettings.isProfessionalStudioEnabled
                             = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _hoisted_63,
                  _createVNode("div", null, [
                    _createVNode("div", _hoisted_64, [
                      _createVNode("div", _hoisted_65, [
                        _createVNode("h4", _hoisted_66, _toDisplayString(_ctx.$t("AppResource.Intercom").toLowerCase()), 1),
                        _createVNode(_component_Button, {
                          disabled: !_ctx.plantC300EosSettingsEditEnabled,
                          class: "p-button-rounded p-button-outlined py-1",
                          onClick: _cache[7] || (_cache[7] = ($event: any) => (
                                    _ctx.addVdeFunction(
                                        'Intercom',
                                        _ctx.IntercomType,
                                        _ctx.INTERCOM_TYPE
                                    )
                                ))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                        require(`@/assets/images/icons/icon-add.svg`)
                                    ,
                              class: "mr-1 bt-icon--2xs"
                            }, null, 8, ["src"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.c300eosSettings.vdeIntercomFunctions, (o, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          _createVNode("div", _hoisted_67, [
                            _createVNode("span", null, [
                              _hoisted_68,
                              _createTextVNode(" " + _toDisplayString(o.description), 1)
                            ]),
                            _createVNode(_component_ElDropdown, {
                              trigger: "click",
                              placement: "bottom-end",
                              "popper-class": "el-dropdown__popper el-dropdown--context"
                            }, {
                              dropdown: _withId(() => [
                                _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ElDropdownItem, {
                                      onClick: ($event: any) => (
                                                    _ctx.onSelectVdeFunction(
                                                        'Intercom',
                                                        o,
                                                        _ctx.IntercomType,
                                                        _ctx.INTERCOM_TYPE
                                                    )
                                                )
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("button", _hoisted_69, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_ElDropdownItem, {
                                      onClick: ($event: any) => (
                                                    _ctx.toggleDeleteItercomConfirm(
                                                        index
                                                    )
                                                )
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("button", _hoisted_70, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withId(() => [
                                _createVNode(_component_Button, {
                                  disabled: 
                                            !_ctx.plantC300EosSettingsEditEnabled
                                        ,
                                  class: "p-button-text text-dark ml-2"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                                            ,
                                      "aria-label": "icon-ellipsis-v"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_71,
                    _createVNode("div", _hoisted_72, [
                      _createVNode("div", _hoisted_73, [
                        _createVNode("h4", _hoisted_74, _toDisplayString(_ctx.$t("AppResource.Camera").toLowerCase()), 1),
                        _createVNode(_component_Button, {
                          class: "p-button-rounded p-button-outlined py-1",
                          disabled: !_ctx.plantC300EosSettingsEditEnabled,
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (
                                    _ctx.addVdeFunction(
                                        'Camera',
                                        _ctx.CameraType,
                                        _ctx.CAMERA_TYPE
                                    )
                                ))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                        require(`@/assets/images/icons/icon-add.svg`)
                                    ,
                              class: "mr-1 bt-icon--2xs"
                            }, null, 8, ["src"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.c300eosSettings.vdeCameraFunctions, (o, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          _createVNode("div", _hoisted_75, [
                            _createVNode("span", null, [
                              _hoisted_76,
                              _createTextVNode(" " + _toDisplayString(o.description), 1)
                            ]),
                            _createVNode(_component_ElDropdown, {
                              trigger: "click",
                              placement: "bottom-end",
                              "popper-class": "el-dropdown__popper el-dropdown--context"
                            }, {
                              dropdown: _withId(() => [
                                _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ElDropdownItem, {
                                      onClick: ($event: any) => (
                                                    _ctx.onSelectVdeFunction(
                                                        'Camera',
                                                        o,
                                                        _ctx.CameraType,
                                                        _ctx.CAMERA_TYPE
                                                    )
                                                )
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("button", _hoisted_77, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_ElDropdownItem, {
                                      onClick: ($event: any) => (
                                                    _ctx.toggleDeleteCameraConfirm(
                                                        index
                                                    )
                                                )
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("button", _hoisted_78, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withId(() => [
                                _createVNode(_component_Button, {
                                  class: "p-button-text text-dark ml-2",
                                  disabled: 
                                            !_ctx.plantC300EosSettingsEditEnabled
                                        
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                                            ,
                                      "aria-label": "icon-ellipsis-v"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      }), 128))
                    ]),
                    _hoisted_79,
                    _createVNode("div", _hoisted_80, [
                      _createVNode("div", _hoisted_81, [
                        _createVNode("h4", _hoisted_82, _toDisplayString(_ctx.$t("AppResource.Activation").toLowerCase()), 1),
                        _createVNode(_component_Button, {
                          disabled: !_ctx.plantC300EosSettingsEditEnabled,
                          class: "p-button-rounded p-button-outlined py-1",
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (
                                    _ctx.addVdeFunction(
                                        'Activation',
                                        _ctx.ActivationType,
                                        _ctx.ACTIVATION_TYPE
                                    )
                                ))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_InlineSvgScoped, {
                              src: 
                                        require(`@/assets/images/icons/icon-add.svg`)
                                    ,
                              class: "mr-1 bt-icon--2xs"
                            }, null, 8, ["src"]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("AppResource.Add")), 1)
                          ]),
                          _: 1
                        }, 8, ["disabled"])
                      ]),
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.c300eosSettings.vdeActivationFunctions, (o, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, [
                          _createVNode("div", _hoisted_83, [
                            _createVNode("span", null, [
                              _hoisted_84,
                              _createTextVNode(" " + _toDisplayString(o.description), 1)
                            ]),
                            _createVNode(_component_ElDropdown, {
                              trigger: "click",
                              placement: "bottom-end",
                              "popper-class": "el-dropdown__popper el-dropdown--context"
                            }, {
                              dropdown: _withId(() => [
                                _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                                  default: _withId(() => [
                                    _createVNode(_component_ElDropdownItem, {
                                      onClick: ($event: any) => (
                                                    _ctx.onSelectVdeFunction(
                                                        'Activation',
                                                        o,
                                                        _ctx.ActivationType,
                                                        _ctx.ACTIVATION_TYPE
                                                    )
                                                )
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("button", _hoisted_85, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_component_ElDropdownItem, {
                                      onClick: ($event: any) => (
                                                    _ctx.toggleDeleteActivationConfirm(
                                                        index
                                                    )
                                                )
                                    }, {
                                      default: _withId(() => [
                                        _createVNode("button", _hoisted_86, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withId(() => [
                                _createVNode(_component_Button, {
                                  disabled: 
                                            !_ctx.plantC300EosSettingsEditEnabled
                                        ,
                                  class: "p-button-text text-dark ml-2"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_InlineSvgScoped, {
                                      src: 
                                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                                            ,
                                      "aria-label": "icon-ellipsis-v"
                                    }, null, 8, ["src"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.selectedTab === '2')
            ? (_openBlock(), _createBlock("div", _hoisted_87, [
                _createVNode("div", _hoisted_88, [
                  _createVNode("h4", _hoisted_89, _toDisplayString(_ctx.$t("AppResource.Temperature")), 1),
                  _createVNode("div", _hoisted_90, [
                    _createVNode("span", _hoisted_91, _toDisplayString(_ctx.$t("AppResource.TemperatureUpper")), 1),
                    _hoisted_92,
                    _createVNode("div", _hoisted_93, [
                      _createVNode("div", _hoisted_94, _toDisplayString(_ctx.$t("AppResource.TemperatureDisplayInfo")), 1),
                      _createVNode(_component_ToggleSwitchButton, {
                        disabled: !_ctx.plantC300EosSettingsEditEnabled,
                        modelValue: _ctx.c300eosSettings.isTemperatureDisplayed,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.c300eosSettings.isTemperatureDisplayed = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _hoisted_95,
                  _createVNode("div", _hoisted_96, [
                    _createVNode("span", _hoisted_97, _toDisplayString(_ctx.$t("AppResource.UnitMeasureUpper")), 1),
                    _hoisted_98,
                    _createVNode("div", _hoisted_99, [
                      _createVNode("div", _hoisted_100, [
                        _createVNode(_component_RadioButton, {
                          value: 0,
                          name: "option-unitofmeasure",
                          id: `option-unitofmeasure-celsius`,
                          modelValue: _ctx.c300eosSettings.temperatureType,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.c300eosSettings.temperatureType = $event)),
                          disabled: !_ctx.plantC300EosSettingsEditEnabled
                        }, null, 8, ["modelValue", "disabled"]),
                        _createVNode("label", _hoisted_101, _toDisplayString(_ctx.$t("AppResource.CelsiusDegrees")), 1)
                      ]),
                      _createVNode("div", _hoisted_102, [
                        _createVNode(_component_RadioButton, {
                          value: 1,
                          name: "option-unitofmeasure",
                          id: `option-unitofmeasure-fahrenheit`,
                          modelValue: _ctx.c300eosSettings.temperatureType,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.c300eosSettings.temperatureType = $event)),
                          disabled: !_ctx.plantC300EosSettingsEditEnabled
                        }, null, 8, ["modelValue", "disabled"]),
                        _createVNode("label", _hoisted_103, _toDisplayString(_ctx.$t("AppResource.FahrenheitDegrees")), 1)
                      ])
                    ])
                  ]),
                  _hoisted_104,
                  _createVNode("div", _hoisted_105, [
                    _createVNode("h4", _hoisted_106, _toDisplayString(_ctx.$t("AppResource.WaterRecycleUpper").toLowerCase()), 1),
                    _createVNode("div", _hoisted_107, [
                      _createVNode("div", _hoisted_108, _toDisplayString(_ctx.$t("AppResource.WaterRecycleInfo")), 1),
                      _createVNode(_component_ToggleSwitchButton, {
                        disabled: !_ctx.plantC300EosSettingsEditEnabled,
                        modelValue: _ctx.c300eosSettings.isWaterCycleEnabled,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.c300eosSettings.isWaterCycleEnabled = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _createVNode("div", {
                    class: ["setting-item", { disabled: _ctx.c300eosSettings.isWaterCycleEnabled }]
                  }, [
                    _createVNode("span", _hoisted_109, _toDisplayString(_ctx.$t("AppResource.MinutesOpen")), 1),
                    _hoisted_110,
                    _createVNode(_component_Slider, {
                      min: 60,
                      step: 60,
                      max: 3600,
                      modelValue: _ctx.c300eosSettings.minutesToKeepOpen,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.c300eosSettings.minutesToKeepOpen = $event)),
                      disabled: 
                            !_ctx.c300eosSettings.isWaterCycleEnabled ||
                            !_ctx.plantC300EosSettingsEditEnabled
                        
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode("div", _hoisted_111, [
                      _createVNode("sup", null, _toDisplayString(_ctx.c300eosSettings.minutesToKeepOpen &&
                            _ctx.c300eosSettings.minutesToKeepOpen / 60), 1)
                    ])
                  ], 2),
                  _createVNode("div", _hoisted_112, [
                    _createVNode("span", _hoisted_113, _toDisplayString(_ctx.$t("AppResource.AutomaticallyOpenDaysDelay")), 1),
                    _hoisted_114,
                    _createVNode(_component_Slider, {
                      min: 1,
                      max: 30,
                      step: 1,
                      modelValue: _ctx.c300eosSettings.openAutomaticallyDaysDelay,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.c300eosSettings.openAutomaticallyDaysDelay = $event)),
                      disabled: 
                            !_ctx.c300eosSettings.isWaterCycleEnabled ||
                            !_ctx.plantC300EosSettingsEditEnabled
                        
                    }, null, 8, ["modelValue", "disabled"]),
                    _createVNode("div", _hoisted_115, [
                      _createVNode("sup", null, _toDisplayString(_ctx.c300eosSettings.openAutomaticallyDaysDelay), 1)
                    ])
                  ]),
                  _createVNode("div", _hoisted_116, [
                    _createVNode("span", _hoisted_117, _toDisplayString(_ctx.$t("AppResource.OpenPumpsInfo")), 1),
                    _createVNode(_component_ToggleSwitchButton, {
                      disabled: !_ctx.plantC300EosSettingsEditEnabled,
                      modelValue: _ctx.c300eosSettings.arePumpsOpenedAutomatically,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.c300eosSettings.arePumpsOpenedAutomatically = $event))
                    }, null, 8, ["disabled", "modelValue"])
                  ]),
                  _hoisted_118,
                  _createVNode("div", _hoisted_119, [
                    _createVNode("h4", _hoisted_120, _toDisplayString(_ctx.$t("AppResource.InterlockUpper").toLowerCase()), 1),
                    _createVNode("span", _hoisted_121, _toDisplayString(_ctx.$t("AppResource.Settings")), 1),
                    _createVNode("span", _hoisted_122, _toDisplayString(_ctx.c300eosSettings.isInterlockSystemEnabled
                                ? "ON"
                                : "OFF"), 1),
                    _hoisted_123,
                    (
                            _ctx.c300eosSettings.interlockExcludedDevices &&
                            _ctx.c300eosSettings.interlockExcludedDevices.length > 0
                        )
                      ? (_openBlock(), _createBlock("span", _hoisted_124, _toDisplayString(_ctx.$t("AppResource.InterlockException")), 1))
                      : _createCommentVNode("", true),
                    _createVNode("span", _hoisted_125, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.c300eosSettings.interlockExcludedDevices, (device, index) => {
                        return (_openBlock(), _createBlock("div", { key: index }, _toDisplayString(device), 1))
                      }), 128))
                    ])
                  ]),
                  _hoisted_126,
                  _createVNode("div", _hoisted_127, [
                    _createVNode("h4", _hoisted_128, _toDisplayString(_ctx.$t("AppResource.SeasonChangeUpper").toLowerCase()), 1),
                    _createVNode("div", _hoisted_129, [
                      _createVNode("div", _hoisted_130, _toDisplayString(_ctx.$t("AppResource.WaterRecycleInfo")), 1),
                      _createVNode(_component_ToggleSwitchButton, {
                        disabled: !_ctx.plantC300EosSettingsEditEnabled,
                        modelValue: _ctx.c300eosSettings.isKeypadLockOutSeason,
                        "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.c300eosSettings.isKeypadLockOutSeason = $event))
                      }, null, 8, ["disabled", "modelValue"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_131, [
                    _createVNode("div", _hoisted_132, [
                      _createVNode(_component_SelectButton, {
                        modelValue: _ctx.c300eosSettings.isSeasonModeAuto,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.c300eosSettings.isSeasonModeAuto = $event)),
                        options: [
                                {
                                    label: _ctx.$t('AppResource.Manual'),
                                    value: false,
                                },
                                {
                                    label: _ctx.$t('AppResource.Auto'),
                                    value: true,
                                },
                            ],
                        dataKey: "value",
                        optionValue: "value",
                        optionLabel: "label",
                        class: "menu-filters__buttons",
                        disabled: !_ctx.plantC300EosSettingsEditEnabled
                      }, null, 8, ["modelValue", "options", "disabled"])
                    ])
                  ]),
                  (_ctx.c300eosSettings.isSeasonModeAuto)
                    ? (_openBlock(), _createBlock("div", _hoisted_133, [
                        _createVNode("div", _hoisted_134, [
                          (!_ctx.c300eosSettings.isSeasonModeAuto)
                            ? (_openBlock(), _createBlock("p", _hoisted_135, _toDisplayString(_ctx.$t("AppResource.SeasonChangeManualInfo")), 1))
                            : _createCommentVNode("", true),
                          _createVNode("div", _hoisted_136, [
                            _createVNode("div", _hoisted_137, [
                              _createVNode(_component_RadioButton, {
                                value: _ctx.SeasonChangeAutoType.WithDate,
                                name: "option-season",
                                id: `option-season-withdate`,
                                modelValue: 
                                        _ctx.c300eosSettings.seasonChangeAutoType
                                    ,
                                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (
                                        _ctx.c300eosSettings.seasonChangeAutoType
                                     = $event)),
                                disabled: !_ctx.plantC300EosSettingsEditEnabled
                              }, null, 8, ["value", "modelValue", "disabled"]),
                              _createVNode("label", _hoisted_138, _toDisplayString(_ctx.$t("AppResource.WithDateLower")), 1)
                            ]),
                            _createVNode("div", _hoisted_139, [
                              _createVNode(_component_RadioButton, {
                                value: _ctx.SeasonChangeAutoType.WithDevice,
                                name: "option-season",
                                id: `option-season-withcontact`,
                                modelValue: 
                                        _ctx.c300eosSettings.seasonChangeAutoType
                                    ,
                                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (
                                        _ctx.c300eosSettings.seasonChangeAutoType
                                     = $event)),
                                disabled: !_ctx.plantC300EosSettingsEditEnabled
                              }, null, 8, ["value", "modelValue", "disabled"]),
                              _createVNode("label", _hoisted_140, _toDisplayString(_ctx.$t("AppResource.WithContactInterfaceLower")), 1)
                            ]),
                            _createVNode("div", _hoisted_141, [
                              _createVNode(_component_RadioButton, {
                                value: 
                                        _ctx.SeasonChangeAutoType.WithTemperature
                                    ,
                                name: "option-season",
                                id: `option-season-withtemperature`,
                                modelValue: 
                                        _ctx.c300eosSettings.seasonChangeAutoType
                                    ,
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (
                                        _ctx.c300eosSettings.seasonChangeAutoType
                                     = $event)),
                                disabled: !_ctx.plantC300EosSettingsEditEnabled
                              }, null, 8, ["value", "modelValue", "disabled"]),
                              _createVNode("label", _hoisted_142, _toDisplayString(_ctx.$t("AppResource.Whittemperature")), 1)
                            ])
                          ])
                        ]),
                        (
                            _ctx.c300eosSettings.seasonChangeAutoType ==
                            _ctx.SeasonChangeAutoType.WithDate
                        )
                          ? (_openBlock(), _createBlock("div", _hoisted_143, [
                              _createVNode("div", _hoisted_144, [
                                _createVNode("div", _hoisted_145, _toDisplayString(_ctx.$t("AppResource.StartWinterPeriodUpper")), 1),
                                _createVNode("div", null, _toDisplayString(_ctx.c300eosSettings.seasonChangeAutoStartWinterDate?.toLocaleDateString(
                                        undefined,
                                        {
                                            day: "numeric",
                                            month: "long",
                                        }
                                    )), 1)
                              ]),
                              _createVNode("div", _hoisted_146, [
                                _createVNode("div", _hoisted_147, _toDisplayString(_ctx.$t("AppResource.StartSummerPeriodUpper")), 1),
                                _createVNode("div", null, _toDisplayString(_ctx.c300eosSettings.seasonChangeAutoStartSummerDate?.toLocaleDateString(
                                        undefined,
                                        {
                                            day: "numeric",
                                            month: "long",
                                        }
                                    )), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (
                            _ctx.c300eosSettings.isSeasonModeAuto &&
                            _ctx.c300eosSettings.selected3477Device
                        )
                          ? (_openBlock(), _createBlock("div", _hoisted_148, [
                              _createVNode("span", _hoisted_149, _toDisplayString(_ctx.$t("AppResource.DeviceSelectedUpper")), 1),
                              _createVNode("span", _hoisted_150, [
                                _createVNode("div", _hoisted_151, [
                                  _createVNode("div", null, " With model: " + _toDisplayString(_ctx.c300eosSettings.selected3477Device.model) + " - ID: " + _toDisplayString(_ctx.c300eosSettings.selected3477Device.id), 1)
                                ])
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.plantC300EosSettingsEditEnabled)
            ? (_openBlock(), _createBlock("footer", _hoisted_152, [
                _createVNode(_component_Button, {
                  disabled: !_ctx.isSettingsDirty,
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.savePlantC300EOSSettings())),
                  class: "p-button-rounded p-button-raised p-button--m"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("AppResource.Save")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_DialogConfirmChangeLanguage, {
            "is-visible": _ctx.languageChangerVisibility,
            languages: _ctx.validLanguages,
            "selected-language": _ctx.c300eosSettings.language,
            onHideDialog: _ctx.hideConfirm,
            onConfirm: _ctx.handleConfirmLanguage
          }, null, 8, ["is-visible", "languages", "selected-language", "onHideDialog", "onConfirm"]),
          _createVNode(_component_ModalAddEditVdeFunction, {
            "is-visible": _ctx.isSelectVdeFunction,
            "vde-function": _ctx.selectedVdeFunction,
            onHideDialog: _ctx.hideSelectedVdeFunction,
            onConfirm: _ctx.upsertVDEFunction
          }, null, 8, ["is-visible", "vde-function", "onHideDialog", "onConfirm"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
})